<template>
  <div data-testid="temperature-container">
    <label>Temperature</label>
    <md-field>
      <md-input
        id="temperature"
        type="number"
        class="number-input"
        aria-label="Temperature"
        data-testid="temperature-input"
        :value="temperature"
        :disabled="readonly"
        :min="0"
        @input="updateTemperature"
      />
      <span class="md-suffix" data-testid="temperature-unit">{{ unit }}</span>
    </md-field>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  name: 'patient-temperature-input',
  props: {
    caseConf: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    temperature() {
      if (!this.caseConf._initialStates) {
        return;
      }
      const tempState = this.caseConf._initialStates.find(state => state.id === 'temperature');
      if (!tempState) {
        return null;
      }
      const tempValue = tempState.options.value;
      return Math.round(tempValue * 10) / 10; // round to 1 decimal place
    },
    unit() {
      const { temperatureUnits } = this.caseConf;
      if (temperatureUnits === 'FAHRENHEIT') {
        return '°F';
      }
      if (temperatureUnits === 'CELSIUS') {
        return '°C';
      }
      return '';
    },
  },
  watch: {
    'caseConf.temperatureUnits': {
      handler(newVal, oldVal) {
        if ((!oldVal || oldVal === 'FAHRENHEIT') && newVal === 'CELSIUS') {
          this.updateTemperature(this.fahrenheitToCelsius(this.temperature));
        }
        if (oldVal === 'CELSIUS' && newVal === 'FAHRENHEIT') {
          this.updateTemperature(this.celsiusToFahrenheit(this.temperature));
        }
      }
    }
  },
  created() {
    this.emitUpdate = debounce(this.emitUpdate, 3);
  },
  methods: {
    celsiusToFahrenheit(value) {
      return (1.8 * +value) + 32;
    },
    fahrenheitToCelsius(value) {
      return  (+value - 32) / 1.8;
    },
    updateTemperature(value) {
      if (!this.caseConf._initialStates) {
        return;
      }
      const tempIndex = this.caseConf._initialStates.findIndex(state => state.id === 'temperature');
      if (tempIndex < 0) {
        return null;
      }
      const tempState = this.caseConf._initialStates[tempIndex];
      const newTempState = {
        ...tempState,
        options: {
          ...tempState.options,
          value
        }
      };
      this.caseConf._initialStates.splice(tempIndex, 1, newTempState);
      this.emitUpdate({ _initialStates: this.caseConf._initialStates });
    },
    emitUpdate(update) {
      this.$emit('update', update);
    },
  },
};
</script>

<style scoped>
.md-field input {
  width: 52px;
  padding: 0 !important;
  padding-left: 10px !important;
}

.md-suffix {
  right: 30px;
  position: absolute;
}
</style>